const o = window;
o.AS || (o.AS = {}), o.o_global || (o.o_global = {}), o.o_util || (o.o_util = {});
o.__toggles__ || (o.__toggles__ = {});
const otto = o.otto ?? {};
const components = otto.components;
export {
  components as c
};
/*🤫*/
